import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import i18n from './i18n'

import './style.css'
import Home from './views/home'
import NotFound from './views/not-found'

const App = () => {
  // Route wrapper to force language from URL segment
  const LangHome = ({ match }) => {
    React.useEffect(() => {
      const lng = match.params.lng
      if (lng && ['en', 'fr', 'nl', 'de'].includes(lng)) {
        i18n.changeLanguage(lng)
        try {
          window.localStorage.setItem('i18nextLng', lng)
        } catch (e) {}
      }
    }, [match.params.lng])

    return <Home />
  }

  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route exact path='/:lng(en|fr|nl|de)' component={LangHome} />
        <Route path='/booking' component={() => {
          window.location.href = 'https://checkout.lodgify.com/fr/marianne-frammery01/629810/reservation';
          return null;
        }}/>
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
